import { faCheck, faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {
  Button,
  Card,
  Col,
  Container,
  OverlayTrigger,
  Popover,
  Row,
  Tooltip,
} from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { NavLink } from 'react-router-dom';

/**
 *
 */
export const Pricing = () => {
  return (
    <>
      <Helmet>
        <title>Pricing and Plans</title>
      </Helmet>
      <div className="intro">
        <Container className="max-w-xl pt-5 pb-5">
          <Row className="pt-2 mt-5">
            <Col lg={12} className="pb-5 mb-5">
              <h1 className="text-center fw-bold mt-0 text-white">Simple, predictable pricing.</h1>
            </Col>
            <Col lg={6}>
              <Card className="border bg-white">
                <Card.Body className="p-4">
                  <Card.Title className="text-muted text-uppercase text-center font-monospace fw-bold">
                    Agent
                  </Card.Title>
                  <h1 className="fw-normal text-center">
                    $45<small className="h6 text-muted">/month</small>
                  </h1>
                  <hr className="my-4" />
                  <ul className="list-unstyled">
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> Personal Agent Platform
                    </li>
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> SSL data encryption
                    </li>
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> Unlimited Support
                    </li>
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> 1 month free
                    </li>
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> Hourly cloud backups
                    </li>
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> 1 Staff Member
                    </li>
                    <li className="mt-2 text-muted">
                      <FontAwesomeIcon icon={faTimes} /> Agency Platform
                    </li>
                  </ul>
                  <NavLink className="btn btn-lg btn-primary w-100 mt-3" to="/home/sign-up" end>
                    Sign Up
                  </NavLink>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={6}>
              <Card className="border bg-white">
                <Card.Body className="p-4">
                  <Card.Title className="text-muted text-uppercase text-center font-monospace fw-bold">
                    Agency
                  </Card.Title>
                  <h1 className="fw-normal text-center">
                    $55<small className="h6 text-muted">/month</small>
                  </h1>
                  <hr className="my-4" />
                  <ul className="list-unstyled">
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> Personal Agent Platform
                    </li>
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> SSL data encryption
                    </li>
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> Unlimited Support
                    </li>
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> 1 month free
                    </li>
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> Hourly cloud backups
                    </li>
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> 3 Staff Member
                      <OverlayTrigger
                        trigger="click"
                        placement="right"
                        rootClose
                        overlay={
                          <Popover>
                            <Popover.Header as="h3">More Staff Members?</Popover.Header>
                            <Popover.Body>
                              Base price includes up to 3 staff members to have access to your
                              agency platform. Contact{' '}
                              <a
                                target="_blank"
                                href="mailto:support@medicareprocrm.com"
                                rel="noreferrer"
                              >
                                support@medicareprocrm.com
                              </a>{' '}
                              for pricing on more than 3.
                            </Popover.Body>
                          </Popover>
                        }
                      >
                        <FontAwesomeIcon className="ms-2" icon={faInfoCircle} />
                      </OverlayTrigger>
                    </li>
                    <li className="mt-2">
                      <FontAwesomeIcon icon={faCheck} /> Agency Platform
                    </li>
                  </ul>
                  <NavLink className="btn btn-lg btn-primary w-100 mt-3" to="/home/sign-up" end>
                    Sign Up
                  </NavLink>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Container className="pt-5 pb-5 max-w-xl">
        <h1 className="text-center fw-bold mt-5 mb-5">Common Questions?</h1>

        <h5 className="fw-bold">Will my information be secure?</h5>
        <p>
          Absolutely! We go to great lengths to keep your information safe and secure with industry
          standard SSL encryption and daily backups.
        </p>

        <h5 className="fw-bold">Is MedicarePRO | CRM HIPAA compliant?</h5>
        <p>
          Any client documents or PI you store on MedicarePRO | CRM goes through bank vault
          encryption to ensure only you, after providing your credentials, are able to see this
          sensitive data. So yes, we are.
        </p>

        <h5 className="fw-bold">
          If I use MedicarePRO | CRM and then cancel my subscription, can I get my data?
        </h5>
        <p>
          Absolutely! You can either export your data from within the program or let us know and we
          will send it off to you in a secure manner.
        </p>

        <h5 className="fw-bold">How long has MedicarePRO | CRM been around?</h5>
        <p>
          We have been helping agents and agencies since 2015, it's been great and we are excited
          for things to come!
        </p>

        <h5 className="fw-bold">
          If I sign up for an agency platform do I still get to use the agent platform?
        </h5>
        <p>Yes!</p>

        <h5 className="fw-bold">Will my subscription price ever go up?</h5>
        <p>
          Barring extreme hyperinflation or a global economic catastrophe, we see no reason to do
          that to you. No one likes that. If we add some really cool stuff in the future that costs
          a lot of money to implement, we might see if you want to add it onto your platform for an
          additional cost.
        </p>

        <h5 className="fw-bold">If I have questions can I speak to a live person in the USA?</h5>
        <p>
          You bet! We have representatives standing by to help you when you need it. Our support
          email is available 24-7 through{' '}
          <a target="_blank" href="mailto:support@medicareprocrm.com" rel="noreferrer">
            support@medicareprocrm.com
          </a>
        </p>
      </Container>
    </>
  );
};
